import { createStore, applyMiddleware, compose } from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import rootReducer from '../reducers';
import authMiddleware from '../middleware/authMiddleware';

/**
 * @description
 * a variable that groups all of the middleware that the store requires.
 *
 */
const createStoreWithMiddleware = applyMiddleware(
	authMiddleware,
	apiMiddleware,
)(createStore);
export default function configureStore (initialState) {
	return createStoreWithMiddleware(
		rootReducer,
		initialState,
		compose(
			typeof window === 'object' && typeof window.devToolsExtension !== 'undefined' ? window.devToolsExtension() : (f) => f,
		),
	);
}
